<template>
	<div class="page">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<el-button type="success" round size="small" @click="dialogVisibleAdd = true">
				<span class="el-icon-plus"></span>
				添加账号
			</el-button>
		</div>
		<div class="page-main">
			<el-card class="box-card">
				<div slot="header" class="flex justify-between align-center">
					<div class="title">
						<span class="el-icon-search"></span>
						<span class="text-bold margin-left-sm">信息检索</span>
					</div>
					<div class="action"><el-button type="warning" size="small" @click="disableAbnormal">禁用非在职</el-button></div>
				</div>
				<el-form :inline="true" :model="formSearch" class="demo-form-inline">
					<el-form-item label="登陆账号"><el-input v-model="formSearch.data.username" clearable placeholder="精确查找" style="width: 150px;"></el-input></el-form-item>
					<el-form-item label="状态">
						<el-select v-model="formSearch.data.state" clearable placeholder="状态" style="width: 120px;">
							<el-option label="全部" value=""></el-option>
							<el-option label="正常" value="1"></el-option>
							<el-option label="禁用" value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="姓名"><el-input v-model="formSearch.data.name" clearable placeholder="模糊搜索" style="width: 180px;"></el-input></el-form-item>
					<el-form-item label="工号">
						<el-input v-model="formSearch.data.officeid" maxlength="11" clearable placeholder="精确查找" style="width: 150px;"></el-input>
					</el-form-item>
					<el-form-item label="手机号">
						<el-input v-model="formSearch.data.mobile" maxlength="11" clearable placeholder="精确查找" style="width: 150px;"></el-input>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="getUserList">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table :data="tableData" style="width: 100%" stripe v-loading="loading" element-loading-text="加载中..." element-loading-spinner="el-icon-loading">
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>

					<el-table-column prop="username" align="center" label="登陆账号" width="220">
						<template slot-scope="scope">
							<span class="text-bold text-blue">{{ scope.row.username }}</span>
						</template>
					</el-table-column>
					<el-table-column align="center" label="状态" width="120">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66" @change="changeUserState(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column align="left" label="绑定员工">
						<template slot-scope="scope">
							<div class="flex align-center">
								<div class="avatar">
									<el-avatar :size="64" :src="scope.row.employee.avatar" v-if="scope.row.employee.avatar"></el-avatar>
									<el-avatar :size="64" icon="el-icon-user-solid" v-else></el-avatar>
								</div>
								<div class="margin-left text-left">
									<div class="text-bold">
										<span class="text-blue" v-if="scope.row.employee.gender == 1">{{ scope.row.employee.name }}</span>
										<span class="text-pink" v-else-if="scope.row.employee.gender == 2">{{ scope.row.employee.name }}</span>
										<span class="text-black" v-else>{{ scope.row.employee.name }}</span>
										<el-tag size="mini" effect="plain" type="info" class="margin-left-xs">{{ scope.row.employee.officeid }}</el-tag>
										<el-tag size="mini" effect="light" type="danger" class="margin-left-xs" v-if="scope.row.employee.stateflag == 0">离职</el-tag>
									</div>
									<div class="text-purple">{{ scope.row.employee.position }}</div>
									<div class="text-grey text-left">{{ scope.row.employee.mobile }}</div>
								</div>
							</div>
						</template>
					</el-table-column>
					<el-table-column prop="logintimes" align="center" label="登陆次数" width="100"></el-table-column>
					<el-table-column prop="addtime" align="center" label="创建时间" width="180"></el-table-column>
					<el-table-column prop="firstlogintime" align="center" label="首次登陆" width="180"></el-table-column>
					<el-table-column prop="lastlogintime" align="center" label="最后登陆" width="180"></el-table-column>
					<el-table-column align="center" label="操作" width="120">
						<template slot-scope="scope">
							<el-button size="small" type="warning" @click="modifyUser(scope.row)">
								<span class="el-icon-edit"></span>
								修 改
							</el-button>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="formSearch.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="20"
						layout="total, sizes, prev, pager, next, jumper"
						:total="total"
					></el-pagination>
				</div>
			</el-card>
		</div>

		<!-- 添加账号 -->
		<el-dialog :show-close="false" append-to-body :visible.sync="dialogVisibleAdd" width="500px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-user text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">添加账号</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleAdd = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding-top-lg" v-loading="loadingAdd">
				<el-form :model="formAdd" ref="formAdd" label-suffix=":" label-width="100px">
					<el-form-item label="账号" prop="username" :rules="{ required: true, message: '请输入登陆账号', trigger: 'blur' }">
						<el-input v-model="formAdd.username" placeholder="请输入登陆账号" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="状态"><el-switch v-model="formAdd.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch></el-form-item>
					<el-form-item label="密码" prop="username" :rules="{ required: true, message: '请输入登陆密码', trigger: 'blur' }">
						<el-input v-model="formAdd.password" placeholder="请输入登陆密码" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="绑定员工" prop="employee" :rules="{ required: true, message: '请选择绑定人员', trigger: 'blur' }">
						<div class="flex align-center" style="line-height: 20px;" v-if="formAdd.employee">
							<div class="avatar">
								<el-avatar :size="40" :src="formAdd.employee.avatar" v-if="formAdd.employee.avatar"></el-avatar>
								<el-avatar :size="40" icon="el-icon-user-solid" v-else></el-avatar>
							</div>
							<div class="margin-left-sm text-left  flex flex-direction justify-center">
								<div class="text-bold">
									<span class="text-blue" v-if="formAdd.employee.gender == 1">{{ formAdd.employee.name }}</span>
									<span class="text-pink" v-else-if="formAdd.employee.gender == 2">{{ formAdd.employee.name }}</span>
									<span class="text-black" v-else>{{ formAdd.employee.name }}</span>
									<el-tag size="mini" effect="plain" type="info" class="margin-left-xs">{{ formAdd.employee.officeid }}</el-tag>
									<el-tag size="mini" effect="light" type="danger" class="margin-left-xs" v-if="formAdd.employee.state == 0">离职</el-tag>
								</div>
								<div class="text-purple">{{ formAdd.employee.position }}</div>
							</div>
							<el-button type="text" class="margin-left text-xl text-gray" @click="formAdd.employee = null"><i class="el-icon-circle-close"></i></el-button>
						</div>
						<el-button size="medium" round @click="checkEmployeeShow = true" v-else>
							点击选择
							<i class="el-icon-arrow-down"></i>
						</el-button>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="">
						<el-button type="primary" @click="formSubmitAdd">
							<i class="el-icon-s-promotion margin-right-xs"></i>
							提 交
						</el-button>
						<el-button @click="formAddInit">清 除</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<!-- 修改账号信息 -->
		<el-dialog :show-close="false" append-to-body :visible.sync="dialogVisibleModify" width="500px">
			<div slot="title" class="flex align-center justify-between">
				<div class="flex align-center">
					<span class="el-icon-user text-gray text-xxl"></span>
					<div class="margin-left-xs"><div class="text-bold">修改账号信息</div></div>
				</div>
				<el-link :underline="false" type="info" @click="dialogVisibleModify = false"><i class="el-icon-close text-xxl"></i></el-link>
			</div>
			<div class="padding-top-lg" v-loading="loadingModify">
				<el-form :model="formModify" ref="formModify" label-suffix=":" label-width="100px">
					<el-form-item label="账号" prop="username" :rules="{ required: true, message: '请输入登陆账号', trigger: 'blur' }">
						<el-input v-model="formModify.username" placeholder="请输入登陆账号" style="width: 220px;"></el-input>
					</el-form-item>
					<el-form-item label="状态"><el-switch v-model="formModify.stateflag" :active-value="1" :inactive-value="0" active-color="#13ce66"></el-switch></el-form-item>
					<el-form-item label="密码" prop="password"><el-input v-model="formModify.password" placeholder="不修改请留空" style="width: 220px;"></el-input></el-form-item>
					<el-form-item label="绑定员工">
						<div class="flex align-center" style="line-height: 20px;">
							<div class="avatar">
								<el-avatar :size="40" :src="userModify.employee.avatar" v-if="userModify.employee.avatar"></el-avatar>
								<el-avatar :size="40" icon="el-icon-user-solid" v-else></el-avatar>
							</div>
							<div class="margin-left-sm text-left  flex flex-direction justify-center">
								<div class="text-bold">
									<span class="text-blue" v-if="userModify.employee.gender == 1">{{ userModify.employee.name }}</span>
									<span class="text-pink" v-else-if="userModify.employee.gender == 2">{{ userModify.employee.name }}</span>
									<span class="text-black" v-else>{{ userModify.employee.name }}</span>
									<el-tag size="mini" effect="plain" type="info" class="margin-left-xs">{{ userModify.employee.officeid }}</el-tag>
									<el-tag size="mini" effect="light" type="danger" class="margin-left-xs" v-if="userModify.employee.stateflag == 0">离职</el-tag>
								</div>
								<div class="text-purple">{{ userModify.employee.position }}</div>
							</div>
						</div>
					</el-form-item>
					<el-divider></el-divider>
					<el-form-item label="">
						<el-button type="primary" @click="formSubmitUserModify">
							<i class="el-icon-s-promotion margin-right-xs"></i>
							提 交
						</el-button>
						<el-button @click="dialogVisibleModify = false">取 消</el-button>
					</el-form-item>
				</el-form>
			</div>
		</el-dialog>

		<check-employee :show="checkEmployeeShow" @close="checkEmployeeShow = false" @change="changeEmployee" type="single"></check-employee>
	</div>
</template>

<script>
import checkEmployee from '@/components/check-employee.vue';
export default {
	components: { checkEmployee },
	data() {
		return {
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			total: 0,
			loading: false,
			tableData: [],
			checkEmployeeShow: false,
			dialogVisibleAdd: false,
			loadingAdd: false,
			formAdd: {
				username: '',
				password: '',
				stateflag: 1,
				employee: null
			},
			dialogVisibleModify: false,
			loadingModify: false,
			userModify: {
				employee: {}
			},
			formModify: {}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getUserList();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		disableAbnormal() {
			const loading = this.$loading({
				lock: false,
				text: '处理中...',
				spinner: 'el-icon-loading',
				background: 'rgba(0, 0, 0, 0.7)'
			});
			this.$http.post('/server/index.php?m=manager/user&a=disableAbnormal', {}).then(
				res => {
					loading.close();
					if (res.result == 'ok') {
						this.$message({
							message: '操作成功',
							type: 'success'
						});

						this.getUserList();
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					loading.close();
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		getUserList() {
			this.loading = true;
			this.$http.post('/server/index.php?m=manager/user&a=getUserList', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.total = res.data.total;
						this.tableData = res.data.infos;
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getUserList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getUserList();
		},
		changeEmployee(val) {
			console.log(val);
			this.formAdd.employee = Object.assign({}, val.data);
		},
		formAddInit() {
			this.formAdd = Object.assign(
				{},
				{
					username: '',
					password: '',
					stateflag: 1,
					employee: null
				}
			);
		},
		formSubmitAdd() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					this.loadingAdd = true;
					this.$http.post('/server/index.php?m=manager/user&a=addUser', this.formAdd).then(
						res => {
							this.loadingAdd = false;
							if (res.result == 'ok') {
								this.$message('添加成功！', {
									type: 'success'
								});
								this.dialogVisibleAdd = false;
								this.getUserList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingAdd = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					console.log('error submit!!');
				}
			});
		},
		changeUserState(user) {
			console.log(user);
			user.stateflag = 1 - user.stateflag;
			this.$confirm('确定要' + (user.stateflag ? '禁用' : '启用') + '账号【' + user.username + '】？', '操作确认', {
				type: 'warning'
			})
				.then(async () => {
					const loading = this.$loading({
						lock: true,
						text: '处理中...',
						background: 'rgba(0, 0, 0, 0.7)'
					});
					this.$http.post('/server/index.php?m=manager/user&a=changeUserState', { id: user.user_id }).then(
						res => {
							loading.close();
							if (res.result == 'ok') {
								this.$alert('修改账号登陆状态成功！', {
									title: '操作成功',
									type: 'success',
									callback: () => {
										this.getUserList();
									}
								});
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							loading.close();
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				})
				.catch(() => {});
		},
		modifyUser(data) {
			this.dialogVisibleModify = true;
			this.userModify = Object.assign({}, data);
			this.formModify = { user_id: data.user_id, username: data.username, stateflag: data.stateflag };
		},
		formSubmitUserModify() {
			this.$refs['formModify'].validate(valid => {
				if (valid) {
					this.loadingModify = true;
					this.$http.post('/server/index.php?m=manager/user&a=modifyUser', this.formModify).then(
						res => {
							this.loadingModify = false;
							if (res.result == 'ok') {
								this.$message('修改成功！', {
									type: 'success'
								});
								this.dialogVisibleModify = false;
								this.getUserList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingModify = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					console.log('error submit!!');
				}
			});
		}
	}
};
</script>

<style></style>
